(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-utils.js', './ktor-ktor-client-core.js', './ktor-ktor-http.js', './ktor-ktor-serialization.js', './ktor-ktor-io.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-utils.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-serialization.js'), require('./ktor-ktor-io.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-serialization'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-serialization' was not found. Please, check whether 'ktor-ktor-serialization' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    root['ktor-ktor-client-content-negotiation'] = factory(typeof this['ktor-ktor-client-content-negotiation'] === 'undefined' ? {} : this['ktor-ktor-client-content-negotiation'], this['kotlin-kotlin-stdlib'], this['ktor-ktor-utils'], this['ktor-ktor-client-core'], this['ktor-ktor-http'], this['ktor-ktor-serialization'], this['ktor-ktor-io']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_io_ktor_ktor_utils, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_serialization, kotlin_io_ktor_ktor_io) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.hb;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var CoroutineImpl = kotlin_kotlin.$_$.j9;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var PipelineContext = kotlin_io_ktor_ktor_utils.$_$.h;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.v8;
  var initMetadataForLambda = kotlin_kotlin.$_$.la;
  var VOID = kotlin_kotlin.$_$.g;
  var HttpResponseContainer = kotlin_io_ktor_ktor_client_core.$_$.q;
  var contentType = kotlin_io_ktor_ktor_http.$_$.f1;
  var suitableCharset = kotlin_io_ktor_ktor_serialization.$_$.f;
  var plus = kotlin_kotlin.$_$.u7;
  var toMutableSet = kotlin_kotlin.$_$.p8;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var register$default = kotlin_io_ktor_ktor_serialization.$_$.b;
  var Configuration = kotlin_io_ktor_ktor_serialization.$_$.c;
  var AttributeKey = kotlin_io_ktor_ktor_utils.$_$.m;
  var Phases_getInstance = kotlin_io_ktor_ktor_client_core.$_$.c;
  var Phases_getInstance_0 = kotlin_io_ktor_ktor_client_core.$_$.f;
  var HttpClientPlugin = kotlin_io_ktor_ktor_client_core.$_$.i;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var toString = kotlin_kotlin.$_$.lb;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
  var accept = kotlin_io_ktor_ktor_client_core.$_$.o;
  var Collection = kotlin_kotlin.$_$.g5;
  var isInterface = kotlin_kotlin.$_$.va;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.p;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var contentType_0 = kotlin_io_ktor_ktor_http.$_$.e1;
  var EmptyContent_getInstance = kotlin_io_ktor_ktor_client_core.$_$.g;
  var Unit = kotlin_kotlin.$_$.ye;
  var charset = kotlin_io_ktor_ktor_http.$_$.c1;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.g;
  var ensureNotNull = kotlin_kotlin.$_$.ef;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var equals = kotlin_kotlin.$_$.z9;
  var joinToString = kotlin_kotlin.$_$.i7;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ja;
  var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.h1;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.k;
  var deserialize = kotlin_io_ktor_ktor_serialization.$_$.a;
  var Exception = kotlin_kotlin.$_$.ge;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.j1;
  var captureStack = kotlin_kotlin.$_$.r9;
  var KtorSimpleLogger = kotlin_io_ktor_ktor_utils.$_$.g;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.t4;
  var HttpStatusCode = kotlin_io_ktor_ktor_http.$_$.s;
  var getKClass = kotlin_kotlin.$_$.f;
  var setOf = kotlin_kotlin.$_$.d8;
  var startsWith = kotlin_kotlin.$_$.ed;
  var endsWith = kotlin_kotlin.$_$.gc;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.w;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ConverterRegistration, 'ConverterRegistration');
  initMetadataForClass(ContentNegotiation$Config$defaultMatcher$1);
  initMetadataForLambda(ContentNegotiation$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(ContentNegotiation$Plugin$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config, 'Config', Config, VOID, [Configuration]);
  initMetadataForObject(Plugin, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForCoroutine($convertRequestCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($convertResponseCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(ContentNegotiation, 'ContentNegotiation', VOID, VOID, VOID, [2, 5]);
  initMetadataForClass(ContentConverterException, 'ContentConverterException', VOID, Exception);
  initMetadataForObject(JsonContentTypeMatcher, 'JsonContentTypeMatcher');
  //endregion
  function get_LOGGER() {
    _init_properties_ContentNegotiation_kt__o183go();
    return LOGGER;
  }
  var LOGGER;
  function get_DefaultCommonIgnoredTypes() {
    _init_properties_ContentNegotiation_kt__o183go();
    return DefaultCommonIgnoredTypes;
  }
  var DefaultCommonIgnoredTypes;
  function ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher) {
    this.t4s_1 = converter;
    this.u4s_1 = contentTypeToSend;
    this.v4s_1 = contentTypeMatcher;
  }
  function defaultMatcher($this, pattern) {
    return new ContentNegotiation$Config$defaultMatcher$1(pattern);
  }
  function ContentNegotiation$Config$defaultMatcher$1($pattern) {
    this.w4s_1 = $pattern;
  }
  protoOf(ContentNegotiation$Config$defaultMatcher$1).x4s = function (contentType) {
    return contentType.h3e(this.w4s_1);
  };
  function ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation) {
    this.g4t_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$Plugin$install$slambda).u3s = function ($this$intercept, it, $completion) {
    var tmp = this.v3s($this$intercept, it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.u3s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.j8_1 = 1;
            suspendResult = this.g4t_1.n4t(this.h4t_1.p3b_1, this.h4t_1.s3a(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.j4t_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (this.j4t_1 == null) {
              return Unit_instance;
            } else {
              tmp_1 = this.j4t_1;
            }

            tmp_0.k4t_1 = tmp_1;
            this.j8_1 = 2;
            suspendResult = this.h4t_1.t3a(this.k4t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).v3s = function ($this$intercept, it, completion) {
    var i = new ContentNegotiation$Plugin$install$slambda(this.g4t_1, completion);
    i.h4t_1 = $this$intercept;
    i.i4t_1 = it;
    return i;
  };
  function ContentNegotiation$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.u3s($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation) {
    this.w4t_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$Plugin$install$slambda_1).o3t = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.p3t($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.o3t(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.z4t_1 = this.y4t_1.vd();
            this.a4u_1 = this.y4t_1.wd();
            var tmp_0 = this;
            var tmp0_elvis_lhs = contentType(this.x4t_1.p3b_1.b3t());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              this.x4t_1;
              get_LOGGER().m3c('Response doesn\'t have "Content-Type" header, skipping ContentNegotiation plugin');
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.b4u_1 = tmp_1;
            this.c4u_1 = suitableCharset(this.x4t_1.p3b_1.j3w().p3i());
            this.j8_1 = 1;
            suspendResult = this.w4t_1.g4u(this.x4t_1.p3b_1.j3w().m3w(), this.z4t_1, this.a4u_1, this.b4u_1, this.c4u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.d4u_1 = suspendResult;
            var tmp_2 = this;
            var tmp_3;
            if (this.d4u_1 == null) {
              return Unit_instance;
            } else {
              tmp_3 = this.d4u_1;
            }

            tmp_2.e4u_1 = tmp_3;
            this.f4u_1 = new HttpResponseContainer(this.z4t_1, this.e4u_1);
            this.j8_1 = 2;
            suspendResult = this.x4t_1.t3a(this.f4u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).p3t = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new ContentNegotiation$Plugin$install$slambda_1(this.w4t_1, completion);
    i.x4t_1 = $this$intercept;
    i.y4t_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function ContentNegotiation$Plugin$install$slambda_2($plugin, resultContinuation) {
    var i = new ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.o3t($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Config() {
    this.h4u_1 = toMutableSet(plus(get_DefaultIgnoredTypes(), get_DefaultCommonIgnoredTypes()));
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.i4u_1 = ArrayList_init_$Create$();
  }
  protoOf(Config).j3p = function (contentType, converter, configuration) {
    var matcher = contentType.equals(Application_getInstance().a3d_1) ? JsonContentTypeMatcher_instance : defaultMatcher(this, contentType);
    this.j4u(contentType, converter, matcher, configuration);
  };
  protoOf(Config).j4u = function (contentTypeToSend, converter, contentTypeMatcher, configuration) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    configuration(converter);
    var registration = new ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher);
    this.i4u_1.e(registration);
  };
  function Plugin() {
    Plugin_instance = this;
    this.k4u_1 = new AttributeKey('ContentNegotiation');
  }
  protoOf(Plugin).u = function () {
    return this.k4u_1;
  };
  protoOf(Plugin).l4u = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var config = this_0;
    return new ContentNegotiation(config.i4u_1, config.h4u_1);
  };
  protoOf(Plugin).f3v = function (block) {
    return this.l4u(block);
  };
  protoOf(Plugin).m4u = function (plugin, scope) {
    var tmp = Phases_getInstance().y40_1;
    scope.a3s_1.t3b(tmp, ContentNegotiation$Plugin$install$slambda_0(plugin, null));
    var tmp_0 = Phases_getInstance_0().a3v_1;
    scope.b3s_1.t3b(tmp_0, ContentNegotiation$Plugin$install$slambda_2(plugin, null));
  };
  protoOf(Plugin).g3v = function (plugin, scope) {
    return this.m4u(plugin instanceof ContentNegotiation ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance;
  function Plugin_getInstance() {
    if (Plugin_instance == null)
      new Plugin();
    return Plugin_instance;
  }
  function ContentNegotiation$convertRequest$lambda(it) {
    return toString(it.t4s_1);
  }
  function $convertRequestCOROUTINE$0(_this__u8e3s4, request, body, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v4u_1 = _this__u8e3s4;
    this.w4u_1 = request;
    this.x4u_1 = body;
  }
  protoOf($convertRequestCOROUTINE$0).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 7;
            var tmp0_iterator = this.v4u_1.l4t_1.g();
            while (tmp0_iterator.h()) {
              var element = tmp0_iterator.i();
              l$ret$1: do {
                get_LOGGER().m3c('Adding Accept=' + element.u4s_1.d3e_1 + ' header for ' + this.w4u_1.a3u_1.toString());
                if (this.w4u_1.c3u_1.u38(HttpHeaders_getInstance().m3e_1, element.u4s_1.toString())) {
                  break l$ret$1;
                }
                accept(this.w4u_1, element.u4s_1);
              }
               while (false);
            }

            var tmp_0;
            var tmp_1 = this.x4u_1;
            if (tmp_1 instanceof OutgoingContent) {
              tmp_0 = true;
            } else {
              var tmp$ret$2;
              l$ret$3: do {
                var this_0 = this.v4u_1.m4t_1;
                var tmp_2;
                if (isInterface(this_0, Collection)) {
                  tmp_2 = this_0.o();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$2 = false;
                  break l$ret$3;
                }
                var tmp0_iterator_0 = this_0.g();
                while (tmp0_iterator_0.h()) {
                  var element_0 = tmp0_iterator_0.i();
                  if (element_0.q9(this.x4u_1)) {
                    tmp$ret$2 = true;
                    break l$ret$3;
                  }
                }
                tmp$ret$2 = false;
              }
               while (false);
              tmp_0 = tmp$ret$2;
            }

            if (tmp_0) {
              get_LOGGER().m3c('Body type ' + toString(getKClassFromExpression(this.x4u_1)) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.w4u_1.a3u_1.toString() + '.'));
              return null;
            }

            var tmp_3 = this;
            var tmp0_elvis_lhs = contentType_0(this.w4u_1);
            var tmp_4;
            if (tmp0_elvis_lhs == null) {
              this.v4u_1;
              get_LOGGER().m3c("Request doesn't have Content-Type header. Skipping ContentNegotiation for " + this.w4u_1.a3u_1.toString() + '.');
              return null;
            } else {
              tmp_4 = tmp0_elvis_lhs;
            }

            tmp_3.y4u_1 = tmp_4;
            var tmp_5 = this.x4u_1;
            if (tmp_5 instanceof Unit) {
              get_LOGGER().m3c('Sending empty body for ' + this.w4u_1.a3u_1.toString());
              this.w4u_1.c3u_1.z38(HttpHeaders_getInstance().e3f_1);
              return EmptyContent_getInstance();
            }

            var tmp_6 = this;
            var this_1 = this.v4u_1.l4t_1;
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator_1 = this_1.g();
            while (tmp0_iterator_1.h()) {
              var element_1 = tmp0_iterator_1.i();
              if (element_1.v4s_1.x4s(this.y4u_1)) {
                destination.e(element_1);
              }
            }

            var tmp_7;
            if (!destination.o()) {
              tmp_7 = destination;
            } else {
              tmp_7 = null;
            }

            var tmp1_elvis_lhs = tmp_7;
            var tmp_8;
            if (tmp1_elvis_lhs == null) {
              this.v4u_1;
              get_LOGGER().m3c('None of the registered converters match request Content-Type=' + this.y4u_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.w4u_1.a3u_1.toString() + '.'));
              return null;
            } else {
              tmp_8 = tmp1_elvis_lhs;
            }

            tmp_6.z4u_1 = tmp_8;
            if (this.w4u_1.c4j() == null) {
              get_LOGGER().m3c('Request has unknown body type. Skipping ContentNegotiation for ' + this.w4u_1.a3u_1.toString() + '.');
              return null;
            }

            this.w4u_1.c3u_1.z38(HttpHeaders_getInstance().e3f_1);
            this.j8_1 = 1;
            continue $sm;
          case 1:
            var tmp_9 = this;
            tmp_9.b4v_1 = this.z4u_1;
            this.c4v_1 = this.b4v_1.g();
            this.j8_1 = 2;
            continue $sm;
          case 2:
            if (!this.c4v_1.h()) {
              this.j8_1 = 5;
              continue $sm;
            }

            this.d4v_1 = this.c4v_1.i();
            var tmp_10 = this;
            tmp_10.e4v_1 = this.d4v_1;
            this.j8_1 = 3;
            var tmp0_elvis_lhs_0 = charset(this.y4u_1);
            var tmp_11 = tmp0_elvis_lhs_0 == null ? Charsets_getInstance().w30_1 : tmp0_elvis_lhs_0;
            var tmp_12 = ensureNotNull(this.w4u_1.c4j());
            var this_2 = this.x4u_1;
            var tmp_13;
            if (!equals(this_2, NullBody_instance)) {
              tmp_13 = this_2;
            } else {
              tmp_13 = null;
            }

            suspendResult = this.e4v_1.t4s_1.m3p(this.y4u_1, tmp_11, tmp_12, tmp_13, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var result = suspendResult;
            if (!(result == null)) {
              get_LOGGER().m3c('Converted request body using ' + toString(this.e4v_1.t4s_1) + ' for ' + this.w4u_1.a3u_1.toString());
            }

            var result_0 = result;
            if (!(result_0 == null)) {
              this.a4v_1 = result_0;
              this.j8_1 = 6;
              continue $sm;
            } else {
              this.j8_1 = 4;
              continue $sm;
            }

          case 4:
            this.j8_1 = 2;
            continue $sm;
          case 5:
            this.a4v_1 = null;
            if (false) {
              this.j8_1 = 1;
              continue $sm;
            }

            this.j8_1 = 6;
            continue $sm;
          case 6:
            var tmp2_elvis_lhs = this.a4v_1;
            var tmp_14;
            if (tmp2_elvis_lhs == null) {
              var tmp_15 = "Can't convert " + toString(this.x4u_1) + ' with contentType ' + this.y4u_1.toString() + ' using converters ';
              throw new ContentConverterException(tmp_15 + joinToString(this.z4u_1, VOID, VOID, VOID, VOID, VOID, ContentNegotiation$convertRequest$lambda));
            } else {
              tmp_14 = tmp2_elvis_lhs;
            }

            var serializedContent = tmp_14;
            return serializedContent;
          case 7:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 7) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function $convertResponseCOROUTINE$1(_this__u8e3s4, requestUrl, info, body, responseContentType, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n4v_1 = _this__u8e3s4;
    this.o4v_1 = requestUrl;
    this.p4v_1 = info;
    this.q4v_1 = body;
    this.r4v_1 = responseContentType;
    this.s4v_1 = charset;
  }
  protoOf($convertResponseCOROUTINE$1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            var tmp_0 = this.q4v_1;
            if (!isInterface(tmp_0, ByteReadChannel)) {
              get_LOGGER().m3c('Response body is already transformed. Skipping ContentNegotiation for ' + this.o4v_1.toString() + '.');
              return null;
            }

            if (this.n4v_1.m4t_1.r(this.p4v_1.h3c_1)) {
              get_LOGGER().m3c('Response body type ' + toString(this.p4v_1.h3c_1) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.o4v_1.toString() + '.'));
              return null;
            }

            var tmp_1 = this;
            var this_0 = this.n4v_1.l4t_1;
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator = this_0.g();
            while (tmp0_iterator.h()) {
              var element = tmp0_iterator.i();
              if (element.v4s_1.x4s(this.r4v_1)) {
                destination.e(element);
              }
            }

            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            var tmp0_iterator_0 = destination.g();
            while (tmp0_iterator_0.h()) {
              var item = tmp0_iterator_0.i();
              destination_0.e(item.t4s_1);
            }

            var tmp_2;
            if (!destination_0.o()) {
              tmp_2 = destination_0;
            } else {
              tmp_2 = null;
            }

            var tmp0_elvis_lhs = tmp_2;
            var tmp_3;
            if (tmp0_elvis_lhs == null) {
              this.n4v_1;
              get_LOGGER().m3c('None of the registered converters match response with Content-Type=' + this.r4v_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.o4v_1.toString() + '.'));
              return null;
            } else {
              tmp_3 = tmp0_elvis_lhs;
            }

            tmp_1.t4v_1 = tmp_3;
            this.j8_1 = 1;
            suspendResult = deserialize(this.t4v_1, this.q4v_1, this.p4v_1, this.s4v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            if (!isInterface(result, ByteReadChannel)) {
              get_LOGGER().m3c('Response body was converted to ' + toString(getKClassFromExpression(result)) + ' for ' + this.o4v_1.toString() + '.');
            }

            return result;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function ContentNegotiation(registrations, ignoredTypes) {
    Plugin_getInstance();
    this.l4t_1 = registrations;
    this.m4t_1 = ignoredTypes;
  }
  protoOf(ContentNegotiation).n4t = function (request, body, $completion) {
    var tmp = new $convertRequestCOROUTINE$0(this, request, body, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(ContentNegotiation).g4u = function (requestUrl, info, body, responseContentType, charset, $completion) {
    var tmp = new $convertResponseCOROUTINE$1(this, requestUrl, info, body, responseContentType, charset, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  function ContentConverterException(message) {
    Exception_init_$Init$(message, this);
    captureStack(this, ContentConverterException);
  }
  var properties_initialized_ContentNegotiation_kt_1ayduy;
  function _init_properties_ContentNegotiation_kt__o183go() {
    if (!properties_initialized_ContentNegotiation_kt_1ayduy) {
      properties_initialized_ContentNegotiation_kt_1ayduy = true;
      LOGGER = KtorSimpleLogger('io.ktor.client.plugins.contentnegotiation.ContentNegotiation');
      DefaultCommonIgnoredTypes = setOf([PrimitiveClasses_getInstance().ua(), PrimitiveClasses_getInstance().qa(), getKClass(HttpStatusCode), getKClass(ByteReadChannel), getKClass(OutgoingContent)]);
    }
  }
  function JsonContentTypeMatcher() {
  }
  protoOf(JsonContentTypeMatcher).x4s = function (contentType) {
    if (contentType.h3e(Application_getInstance().a3d_1)) {
      return true;
    }
    var value = contentType.g3e().toString();
    return startsWith(value, 'application/') && endsWith(value, '+json');
  };
  var JsonContentTypeMatcher_instance;
  function JsonContentTypeMatcher_getInstance() {
    return JsonContentTypeMatcher_instance;
  }
  function get_DefaultIgnoredTypes() {
    _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1();
    return DefaultIgnoredTypes;
  }
  var DefaultIgnoredTypes;
  var properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt;
  function _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1() {
    if (!properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt) {
      properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt = true;
      // Inline function 'kotlin.collections.mutableSetOf' call
      DefaultIgnoredTypes = LinkedHashSet_init_$Create$();
    }
  }
  //region block: post-declaration
  protoOf(Config).k3p = register$default;
  //endregion
  //region block: init
  JsonContentTypeMatcher_instance = new JsonContentTypeMatcher();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Plugin_getInstance;
  //endregion
  return _;
}));
